'use strict';

var $ = require('jquery');
var jqueryI18next = require('jquery-i18next');
var i18next = require('i18next');
var backend = require('i18next-xhr-backend');
var cache = require('i18next-localstorage-cache');

var defaultOptions = {
    //debug: true,
    lng: 'en',
    fallbackLng: 'en',
    //ns: [],
    interpolation: {'escapeValue': false},
    backend: {
        loadPath: function(lng, ns){
            if(ns.indexOf('plan-names') !== -1){
                return '/online-services/plan-names';
            }else{
                return '/groups/' + 'locales/' + lng + '/' + ns + '.json';
            }
        }
    },
    cache:
        {
            enabled: true,
            // prefix for stored languages
            prefix: 'i18next_res_',
            // expiration (10 mins)
            expirationTime: 10 * 60 * 1000
        }
};

function doSetup(options) {
    var mergedOpts = $.extend({}, defaultOptions, options);

    jqueryI18next.init(i18next, $);

    var deferred = $.Deferred();

    i18next.use(backend)
        .use(cache)
        .init(mergedOpts, function(err, t) {
            if (err) {
                console.error(err);//all bad failed to initialize
            } else {
                deferred.resolve(i18next); //now we can translate
            }
        });

    return deferred.promise();
}

/**
 * Returns a function to be used for jquery validator.
 * Validator doesn't support promises, thus we expect i18n has already been initialized
 * if you need regular translations in javascript better use i18next resolved value from i18n.init() promise
 * @param key
 * @returns {Function}
 */
function translate(key) {
    return function() {
        return i18next.t(key);
    };
}

module.exports = {
    doSetup: doSetup,
    translate: translate
};




//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/i18n.js
// module id = lwx0
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14